import { gql } from "@apollo/client";

export const FIND_EXTERNAL_ORDER = gql`
  query findExternalOrderByQuarterly($quarterly: Int!, $year: Int!) {
    findExternalOrderByQuarterly(quarterly: $quarterly, year: $year) {
      id
      eoid
      employee_id
      quarterly
      total_payment_fee
      total_sales
      tax
      type
      admin_fee
      tax_admin_fee
      refund
      company
      mutation_at
      mutation_at_default
      created_at
      updated_at
      additional_fee
      additional
      total_pph_fee
      total_va_fee
      total_transaction_fee
      is_custom_fee
      custom_fee_percentage
      printed_at
      year
      employee {
        id
        name
        role
      }
      client {
        id
        name
        address
        regency
      }
      external_order_details {
        id
        eodid
        external_order_id
        no_reference
        nominal
        transaction_at
        created_at
        updated_at
        tax
        pph_fee
        va_fee
        transaction_fee
        mutation
        mutation_at
      }
    }
  }
`;

export const FIND_EXTERNAL_ORDER_BY_ID = gql`
  query findExternalOrderById($id: ID!) {
    findExternalOrderById(id: $id) {
      id
      eoid
      employee_id
      quarterly
      total_payment_fee
      total_sales
      tax
      type
      admin_fee
      tax_admin_fee
      refund
      company
      mutation_at
      mutation_at_default
      created_at
      updated_at
      additional_fee
      additional
      total_pph_fee
      total_va_fee
      total_transaction_fee
      is_custom_fee
      custom_fee_percentage
      printed_at
      year
      employee {
        id
        name
        role
      }
      client {
        id
        name
        address
        regency
      }
      external_order_details {
        id
        eodid
        external_order_id
        no_reference
        nominal
        transaction_at
        created_at
        updated_at
        tax
        pph_fee
        va_fee
        transaction_fee
        mutation
        mutation_at
      }
    }
  }
`;

export const FIND_EXTERNAL_ORDER_BY_REFERENCE = gql`
  query findExternalOrderByReference($reference: String!) {
    findExternalOrderByReference(reference: $reference) {
      id
    }
  }
`;

export const CREATE_EXTERNAL_ORDER = gql`
  mutation createExternalOrder($data: InExternalOrder!) {
    createExternalOrder(data: $data) {
      id
      eoid
    }
  }
`;

export const UPDATE_EXTERNAL_ORDER_PRINTED_AT = gql`
  mutation updateExternalOrderPrintedAt($id: ID!, $printed_at: DateTime!) {
    updateExternalOrderPrintedAt(id: $id, printed_at: $printed_at) {
      id
      eoid
      printed_at
    }
  }
`;

export const DELETE_EXTERNAL_ORDER = gql`
  mutation deleteExternalOrder($id: ID!) {
    deleteExternalOrder(id: $id)
  }
`;
